import React from "react";
import './Technology.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
 
 
import 'bootstrap/dist/css/bootstrap.min.css';
 

const Technology = ()=> {

 

    return (
        <>
            <AIheader/>

 

            {/* START techBannerMain */}
            <section className='techBannerMain'>
                <div className='container'>
                    <div className='techBannerOuter'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                                <div className='techBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="Our technology"/> Technologies</h1>
                                    <p>Our technology. <br/>Your rental brand.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END techBannerMain */}
 
 
             {/* START platformSec */}
             <section className="platformSec">
                <div className="container"> 
                    <div className='row align-items-center'>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='platformSecLeft'>
                                <h2>Platform</h2>
                                <p>From on-board to on-rent in less<br/>
                                than 60 minutes, all in one place.</p>
                                <a className="btn btnBlue" href="/platform">Explore More</a>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='platformSecRight'>
                                <figure>
                                    <img className="img-fluid" src="/img/Technology/platform_icon.svg" alt="logo"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END platformSec */} 


             {/* START platformSec */}
             <section className="platformSec technologySec">
                <div className="container"> 
                    <div className='row align-items-center'>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='platformSecRight'>
                                <figure>
                                    <img className="img-fluid" src="/img/Technology/map_icon.svg" alt="logo"/>
                                </figure>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='platformSecLeft'>
                                <h2>Technology</h2>
                                <p>Your rental brand accessible to<br/>
                                renters anywhere & everywhere</p>
                                <a className="btn btnBlue" href="/technology">Explore More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END platformSec */}

             {/* START platformSec */}
             <section className="platformSec enterpriseSec">
                <div className="container"> 
                    <div className='row align-items-center'>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='platformSecLeft'>
                                <h2>Enterprise</h2>
                                <p>Build with our rental workflows<br/>
                                designed to scale any business.</p>
                                <a className="btn btnBlue" href="/enterprise">Explore More</a>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='platformSecRight'>
                                <figure>
                                    <img className="img-fluid" src="/img/Technology/api_icon.svg" alt="logo"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END platformSec */}
   
            <Footer/>
        </>
    )
}

export default Technology;